'use client';

import React, { useState, useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { usePreferences } from '@/context/PreferencesContext';
import { useAuth } from '@/context/AuthContext';
import { getAdSlots } from '@/lib/api-client';
import type { AdSlot } from '@/lib/api-client';
import FooterAdBanner from './FooterAdBanner';
import { isAdExcluded, useGlobalAdExclusions } from '@/hooks/useAdsConfig';

export default function FooterAdWrapper() {
  const { showAds } = usePreferences();
  const { isPro, loading } = useAuth();
  const pathname = usePathname();
  const [footerBanner, setFooterBanner] = useState<AdSlot | undefined>(undefined);
  const globalExcluded = useGlobalAdExclusions();

  const shouldShowAds = isPro ? showAds : true;

  useEffect(() => {
    if (loading || !shouldShowAds) return;
    getAdSlots()
      .then((slots) => {
        setFooterBanner(slots.find((s) => s.slotName === 'footer'));
      })
      .catch(() => {});
  }, [loading, shouldShowAds]);

  if (loading) return null;
  const hideOnPages = ['/login', '/create-account', '/verify-email', '/forgot-password', '/reset-password', '/admin'];
  if (!shouldShowAds) return null;
  if (hideOnPages.some((p) => pathname === p || pathname.startsWith(p + '/'))) return null;
  if (isAdExcluded(footerBanner?.excludedPages ?? [], globalExcluded, pathname)) return null;
  return <FooterAdBanner slot={footerBanner} />;
}
